import TagGridLayout from './containers/Grid';

export default function TagLayout() {
  return <>
    <TagGridLayout />
  </>
}
